export const CURRENCY_LIST = [
    {
        label: 'currency.euro',
        value: '€'
    },
    {
        label: 'currency.usdollar',
        value: 'US$'
    },
    {
        label: '----------------',
        value: ''
    },
    {
        label: 'currency.australiandollar',
        value: 'A$'
    },
    {
        label: 'currency.canadiandollar',
        value: 'C$'
    },
    {
        label: 'currency.hongkongdollar',
        value: 'HK$'
    },
    {
        label: 'currency.japaneseyen',
        value: '¥'
    },
    {
        label: 'currency.mexicanpeso',
        value: 'MXN$'
    },
    {
        label: 'currency.pundsterling',
        value: '£'
    },
    {
        label: 'currency.renminbi',
        value: 'CNY'
    },
    {
        label: 'currency.russianruble',
        value: '₽'
    },
    {
        label: 'currency.singaporedollar',
        value: 'S$'
    },
    {
        label: 'currency.swedishkrona',
        value: 'SEK'
    },
    {
        label: 'currency.argentinianpeso',
        value: 'ARS$'
    },
    {
        label: 'currency.brizilianreal',
        value: 'R$'
    },
    {
        label: 'currency.chileanpeso',
        value: 'CLP$'
    },
    {
        label: 'currency.colombianpeso',
        value: 'COL$'
    },
    {
        label: 'currency.czechkoruna',
        value: 'Kč'
    },
    {
        label: 'currency.danishkrone',
        value: 'DKK'
    },
    {
        label: 'currency.israelinewshekel',
        value: '₪'
    },
    {
        label: 'currency.norwegiankrone',
        value: 'NOK'
    },
    {
        label: 'currency.polishzloti',
        value: 'zł'
    },
    {
        label: 'currency.swissfranc',
        value: 'CHF'
    }
];
//# sourceMappingURL=index.js.map